var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-r align-center team-item-wrapper",on:{"click":function($event){$event.stopPropagation();return (() => _vm.handleClick(_vm.teamId)).apply(null, arguments)}}},[_c('profile-picture',{attrs:{"name":_vm.name,"isTeam":true}}),_c('label',{staticClass:"team-name ml-05"},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }